<template>
  <div>
    <b-row>
      <b-col>
        <b-form-group
            id="input-group-1"
            class="required"
            label-class="control-label"
            label="Image"
            label-for="input-1"
          ></b-form-group>
        <b-card class="text-center bg-gray-100" style="border-style: dashed;">
          <b-row v-if="veeErrors.first('image')" class="m-lg-1" style="background-color: #FEE8E9; border: 1px solid #ffc4c6; border-radius: 5px;">
            <b-col md="12" id="img-error-report">
              <div style="width: 0%; text-align: center; vertical-align: middle; text-align:center;">
                <img src="@/assets/ic-warning-red.svg" class="ic_warning" style="width:25px; position:absolute; margin:auto; top:0; bottom:0;">
              </div>
              <div style="width: 97%; padding-left: 3%;">
                <ul class="text-left" style="margin: 7px 0px;">
                  <li class="text-danger" v-for="imageErr in veeErrors.collect('image')" :key="imageErr"><span class="text-dark">{{ imageErr }}</span></li>
                </ul>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <img v-if="url" width="100%" height :src="url" />
              <img v-else width="25%" height src="@/assets/image_not_found.png" />
            </b-col>
          </b-row>
          <input
            type="file"
            ref="file"
            style="display: none"
            name="image"
            v-validate="'required|minimalDimensions:1000,500|ratiolDimensions:2,1|size:2000|ext:jpg,png,gif,jpeg'"
            @change="onChangeFileUpload()"
          />
          <br />
          <b-link
            @click="$refs.file.click()"
            v-show="!file"
            variant="primary"
            class="text-primary btn"
          >
            <img class="mr-2" src="@/assets/ic-plus.svg" alt /> <b>Select Image</b>
            <label class="text-danger">*</label>
          </b-link>
          <b-button @click="$refs.file.click()" v-show="file" variant="outline-primary" class>
            <img class="mr-2" src="@/assets/ic-edit.svg" alt /> Edit
          </b-button>
          <br />
          <!-- <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('image') }}</p> -->
          <p
            class="text-gray-500"
          >Image must be at least 1000x500 pixels and maximum 2MB. Must be in <b>JPEG</b>, <b>PNG</b>, or <b>GIF</b> format</p>
        </b-card>
        <br>
        <b-form-group
            id="input-group-1"
            class="required"
            label-class="control-label"
            label="WEBP Image"
            label-for="input-1"
          ></b-form-group>
        <b-card class="text-center bg-gray-100" style="border-style: dashed;">
          <b-row v-if="veeErrors.first('image_webp')" class="m-lg-1" style="background-color: #FEE8E9; border: 1px solid #ffc4c6; border-radius: 5px;">
            <b-col md="12" id="img-error-report">
              <div style="width: 0%; text-align: center; vertical-align: middle; text-align:center;">
                <img src="@/assets/ic-warning-red.svg" class="ic_warning" style="width:25px; position:absolute; margin:auto; top:0; bottom:0;">
              </div>
              <div style="width: 97%; padding-left: 3%;">
                <ul class="text-left" style="margin: 7px 0px;">
                  <li class="text-danger" v-for="imageErr in veeErrors.collect('image_webp')" :key="imageErr"><span class="text-dark">{{ imageErr }}</span></li>
                </ul>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <img v-if="url_webp" width="100%" height :src="url_webp" />
              <img v-else width="25%" height src="@/assets/image_not_found.png" />
            </b-col>
          </b-row>
          <input
            type="file"
            ref="file_webp"
            style="display: none"
            name="image_webp"
            v-validate="'required|minimalDimensions:1000,500|ratiolDimensions:2,1|size:2000|ext:webp'"
            @change="onChangeFileWebp()"
          />
          <br />
          <b-link
            @click="$refs.file_webp.click()"
            v-show="!file_webp"
            variant="primary"
            class="text-primary btn"
          >
            <img class="mr-2" src="@/assets/ic-plus.svg" alt /> <b>Select WEBP Image</b>
            <label class="text-danger">*</label>
          </b-link>
          <b-button @click="$refs.file_webp.click()" v-show="file_webp" variant="outline-primary" class>
            <img class="mr-2" src="@/assets/ic-edit.svg" alt /> Edit
          </b-button>
          <br />
          <!-- <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('image') }}</p> -->
          <p
            class="text-gray-500"
          >Image must be at least 1000x500 pixels and maximum 2MB. Must be in <b>WEBP</b> format</p>
          
        </b-card>
        <br>
        <b-form-group
            id="input-group-1"
            class="required"
            label-class="control-label"
            label="Image Alt Text"
            label-for="input-1"
          >
            <input
              id="input-1"
              type="text"
              class="form-control"
              v-validate="this.category === 'pejuangonline' ? 'required|max:70' : 'required|max:159'"
              name="image_alt"
              data-vv-as="Image Alt Text"
              v-model="image_alt"
              placeholder="Image Alt Text"
            />
            <b-form-invalid-feedback
              id="input-image_alt-feedback"
            >{{ veeErrors.first('image_alt') }}</b-form-invalid-feedback>
          </b-form-group>
        <br />
        <label class="text-danger">
          *
          <b class="text-dark">Required</b>
        </label>
      </b-col>
      <b-col md="8">
        <b-row>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="required"
              label="Category"
              label-for="input-1"
            >
              <b-form-select
                v-model="category"
                name="category"
                v-validate="'required'"
                data-vv-as="Category"
                class="form-control"
              >
                <template v-slot:first>
                  <option value disabled>-- Category --</option>
                </template>
                <option
                  v-for="data in options_category"
                  :key="data.value"
                  :value="data.value"
                >
                  {{ data.text }}
                </option>
              </b-form-select>

              <p
                style="width: 100%; font-size: 80%;color: #dc3545;"
              >
                {{ veeErrors.first("category") }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-show="category === 'promo'">
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              label-class="control-label"
              label="Promo Code"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                v-validate="'alpha_num'"
                name="promo_code"
                v-model="promo_code"
                data-vv-as="Promo Code"
                placeholder="Promo Code"
              />
              <b-form-invalid-feedback
                id="input-promo_code-feedback"
              >{{ veeErrors.first('promo_code') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Title in Bahasa"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                v-validate="this.category === 'pejuangonline' ? 'required|max:70' : 'required|max:159'"
                name="title_id"
                v-model="title_id"
                data-vv-as="Title in Bahasa"
                placeholder="Title in Bahasa"
              />
              <b-form-invalid-feedback
                id="input-title_id-feedback"
              >{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Title in English"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                v-validate="this.category === 'pejuangonline' ? 'required|max:70' : 'required|max:159'"
                name="title_en"
                v-model="title_en"
                data-vv-as="Title in English"
                placeholder="Title in English"
              />
              <b-form-invalid-feedback
                id="input-title_en-feedback"
              >{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Quick / Meta Description Bahasa (Max : 159 karakter)"
              label-for="input-1"
            >
              <textarea
                id="input-1"
                type="text"
                class="form-control"
                v-validate="{required: true, max: 159}"
                name="meta_description_id"
                data-vv-as="Quick / Meta Description Bahasa"
                v-model="meta_description_id"
                placeholder="Quick / Meta Description Bahasa"
                style="height: 70px"
              />
              <b-form-invalid-feedback
                id="input-meta_description_id-feedback"
              >{{ veeErrors.first('meta_description_id') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Quick / Meta Description English (Max : 159 karakter)"
              label-for="input-1"
            >
              <textarea
                id="input-1"
                type="text"
                class="form-control"
                v-validate="{required: true, max: 159}"
                name="meta_description_en"
                data-vv-as="Quick / Meta Description English"
                v-model="meta_description_en"
                placeholder="Quick / Meta Description English"
                style="height: 70px"
              />
              <b-form-invalid-feedback
                id="input-meta_description_en-feedback"
              >{{ veeErrors.first('meta_description_en') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group id="quick-cta-button-fieldset-1" label="Quick CTA Button" label-for="quick-cta-button-radio-group">
              <b-form-radio-group
                id="quick-cta-button-radio-group"
                v-model="is_with_quick_cta_button"
                :options="options_q_cta"
                name="is_with_quick_cta_button"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-show="is_with_quick_cta_button">
          <br />
          <b-col md="6">
            <b-form-group id="quick-cta-button-fieldset-1" class="required" label-class="control-label" label="Quick CTA Button (Bahasa)" label-for="quick-cta-button-1">
              <input
                id="quick-cta-button-1"
                :disabled="is_with_quick_cta_button == false"
                v-model="quick_cta_button_text_id"
                v-validate="'required'"
                data-vv-as="Quick CTA Button Bahasa"
                name="quick_cta_button_text_id"
                class="form-control"
                placeholder="Quick CTA Button in Bahasa"
              />
              <b-form-invalid-feedback
                id="input-quick_cta_button_text_id-feedback"
              >{{ veeErrors.first('quick_cta_button_text_id') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group id="quick-cta-button-fieldset-1" class="required" label-class="control-label" label="Quick CTA Button (English)" label-for="quick-cta-button-2">
              <input
                id="quick-cta-button-2"
                :disabled="is_with_quick_cta_button == false"
                v-model="quick_cta_button_text_en"
                v-validate="'required'"
                data-vv-as="Quick CTA Button English"
                name="quick_cta_button_text_en"
                class="form-control"
                placeholder="Quick CTA Button in English"
              />
              <b-form-invalid-feedback
                id="input-quick_cta_button_text_en-feedback"
              >{{ veeErrors.first('quick_cta_button_text_en') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group id="quick-cta-button-fieldset-1" class="required" label-class="control-label" label="Quick CTA Button URL" label-for="quick-cta-button-3">
              <input
                id="quick-cta-button-3"
                type="url"
                :disabled="is_with_quick_cta_button == false"
                v-model="quick_cta_button_url"
                v-validate="{required: true, url: true}"
                data-vv-as="Quick CTA Button URL"
                name="quick_cta_button_url"
                class="form-control"
                placeholder="Quick CTA Button URL"
              />
              <b-form-invalid-feedback
                id="input-quick_cta_button_url-feedback"
              >{{ veeErrors.first('quick_cta_button_url') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Content Bahasa"
              label-for="input-1"
            >
              <summer-note v-model="content_id" name="content_id" placeholder="Content Bahasa"></summer-note>
              <input type="hidden" v-model="content_id" v-validate="'required'" name="content_id" data-vv-as="Content Bahasa">
              <p
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('content_id') }}</p>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Content English"
              label-for="input-1"
            >
              <summer-note v-model="content_en" name="content_en" placeholder="Content English"></summer-note>
              <input type="hidden" v-model="content_en" v-validate="'required'" name="content_en" data-vv-as="Content English">
              <p
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('content_en') }}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group id="cta-button-fieldset-1" label="CTA Button" label-for="cta-button-1">
              <b-form-radio-group
                id="cta-button-radio-group"
                v-model="is_with_cta_button"
                :options="options_cta"
                name="is_with_cta_button"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-show="is_with_cta_button">
          <br />
          <b-col md="6">
            <b-form-group id="cta-button-fieldset-1" class="required" label-class="control-label" label="CTA Button (Bahasa)" label-for="cta-button-1">
              <input
                id="cta-button-1"
                :disabled="is_with_cta_button == false"
                v-model="cta_button_text_id"
                v-validate="'required'"
                data-vv-as="CTA Button Bahasa"
                name="cta_button_text_id"
                class="form-control"
                placeholder="CTA Button in Bahasa"
              />
              <b-form-invalid-feedback
                id="input-cta_button_text_id-feedback"
              >{{ veeErrors.first('cta_button_text_id') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group id="cta-button-fieldset-1" class="required" label-class="control-label" label="CTA Button (English)" label-for="cta-button-2">
              <input
                id="cta-button-2"
                :disabled="is_with_cta_button == false"
                v-model="cta_button_text_en"
                v-validate="'required'"
                data-vv-as="CTA Button English"
                name="cta_button_text_en"
                class="form-control"
                placeholder="CTA Button in English"
              />
              <b-form-invalid-feedback
                id="input-cta_button_text_en-feedback"
              >{{ veeErrors.first('cta_button_text_en') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group id="cta-button-fieldset-1" class="required" label-class="control-label" label="CTA Button URL" label-for="cta-button-3">
              <input
                id="cta-button-3"
                type="url"
                :disabled="is_with_cta_button == false"
                v-model="cta_button_url"
                v-validate="{required: true, url: true}"
                data-vv-as="CTA Button URL"
                name="cta_button_url"
                class="form-control"
                placeholder="CTA Button URL"
              />
              <b-form-invalid-feedback
                id="input-cta_button_url-feedback"
              >{{ veeErrors.first('cta_button_url') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group id="fieldset-1" label="Tags">
              <div style="padding:10px;border:0.5px solid #dedede">
                <b-row>
                  <b-col md="8">
                    <vue-auto-complete class="auto-input" placeholder="Tag" v-model="tag"></vue-auto-complete>
                  </b-col>
                  <b-col md="4">
                      <a @click="addTags()" style="text-decoration:none;cursor:pointer">
                        <b-button size="sm" variant="light" style="color:#5e50a1" pill>
                          <i class="fas fa-plus"></i>
                        </b-button> Add tag
                      </a>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col style="flex: 2 1 auto;display: flex;flex-wrap:wrap;">
                    <div v-for="(data,index) in tags" :key="data" style="padding:5px;border-radius:5px;margin-right:10px;margin-top:10px;border:0.5px solid #dedede">
                      {{data ? data:''}} <b-button size="sm" variant="light" style="color:#5e50a1" @click="erraseTags(index)" pill>
                          <i class="fas fa-times"></i>
                        </b-button>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-form-group>
            <input type="hidden" v-model="tags" name="tags" data-vv-as="Tags">
              <p
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('tags') }}</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group id="fieldset-1" label="Start Date" label-for="input-1">
              <b-row class="m-0">
                <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                  <img src="@/assets/ic-calendar-copy-30.svg" width="20px" alt class />
                </b-col>
                <b-col class="px-0">
                  <datepicker
                    input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                    placeholder="Select Date"
                    v-model="period_start"
                    :format="customFormatter"
                    :disabledDates="disabledDates"
                  ></datepicker>
                </b-col>
                <b-col align="left" md="1" class="px-0">
                  <b-col
                    align="left"
                    class="pt-1 px-4 form-control del-calender-select border-left-0"
                    md="2"
                  >
                    <b-row align="left" class="pt-1">
                      <b-col>
                        <b-link @click="resetStardate" style="text-decoration:none">
                          <i class="text-danger fas fa-times"></i>
                        </b-link>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="fieldset-1" label="End Date" label-for="input-1">
              <b-row class="m-0">
                <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                  <img src="@/assets/ic-calendar-copy-30.svg" width="20px" alt class />
                </b-col>
                <b-col class="px-0">
                  <datepicker
                    input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                    placeholder="Select Date"
                    v-model="period_end"
                    :format="customFormatter"
                    :disabledDates="disabledPeriodDatesEnd"
                  ></datepicker>
                </b-col>
                <b-col align="left" md="1" class="px-0">
                  <b-col
                    align="left"
                    class="pt-1 px-4 form-control del-calender-select border-left-0"
                    md="2"
                  >
                    <b-row align="left" class="pt-1">
                      <b-col>
                        <b-link @click="resetEnddate" style="text-decoration:none">
                          <i class="text-danger fas fa-times"></i>
                        </b-link>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-col>
              </b-row>
              <br />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-checkbox
              id="is_highlight2"
              v-model="is_highlight"
              name="is_highlight2"
              value="true"
              unchecked-value="false"
              :disabled="counthighlight.total > 5"
            >Set as a Highlight Article ({{counthighlight.total}}/5)</b-form-checkbox>
          </b-col>
        </b-row>
        <br />
        <br />
        <b-row class="mt-2">
          <b-col class="text-left">
              <b-button
                :disabled="loading || isPreviewDisabled"
                @click="previewArticle()"
                class="col-4 mr-3"
                variant="primary"
                size="lg">
                  Preview
              </b-button>
          </b-col>
          <b-col class="text-right">
            <router-link :to="{ name: 'Article' }">
              <b-button :disabled="loading" class="col-4 mr-3" variant="outline-secondary" size="lg">Cancel</b-button>
            </router-link>
            <b-button
              variant="primary"
              :disabled="loading"
              @click="post()"
              class="col-4"
              size="lg"
            >
              Create
              <b-spinner v-if="loading" small label="Loading..."></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import summerNote from "@/components/Summernote.vue";
import VueAutoComplete from './VueAutocomplete.vue';

export default {
  components: {
    Datepicker,
    VueAutoComplete,
    summerNote
  },
  data() {
    return {
      loading: false,
      file: "",
      url: "",
      file_webp: "",
      url_webp: "",
      image_alt: "",
      title_id: "",
      title_en: "",
      content_id: "",
      content_en: "",
      is_with_quick_cta_button: false,
      quick_cta_button_text_id: "",
      quick_cta_button_text_en: "",
      quick_cta_button_url: "",
      is_with_cta_button: false,
      cta_button_text_id: "",
      cta_button_text_en: "",
      cta_button_url: "",
      tag: "",
      tags: [],
      options_q_cta: [
        { text: "No", value: false },
        { text: "Yes", value: true }
      ],
      options_cta: [
        { text: "No", value: false },
        { text: "Yes", value: true }
      ],
      options_category: [
        { text: "News", value: "news" },
        { text: "Promo", value: "promo" },
        { text: "Paxel Market", value: "paxelmarket" },
        { text: "#AntarkanKebaikan", value: "antarkankebaikan" },
        { text: "#PejuangOnline", value: "pejuangonline" },
      ],
      category: "",
      meta_description_id: "",
      meta_description_en: "",
      period_start: "",
      period_end: "",
      promo_code: "",
      is_highlight: false,
      counthighlight: 0,
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      },
    };
  },
  beforeMount(){
    this.$store.dispatch("ArticleModule/getCountHighlight", null, {
      root: true
    });
  },
  mounted(){
    this.$store.watch(
      state => state.ArticleModule.counthighlight,
      (newValue, oldValue) => {
        this.counthighlight = newValue;
      }
    );
  },
  methods: {
    addTags() {
      if (this.tag !== '') {
        this.tags.push(this.tag);
        this.tag = "";
      }
    },
    erraseTags(index) {
      this.tags.splice(index,1);
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    resetStardate() {
      this.period_start = "";
    },
    resetEnddate() {
      this.period_end = "";
    },
    post() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const formData = new FormData();

          formData.append("category", this.category);
          formData.append("image_alt", this.image_alt);
          formData.append("title_id", this.title_id);
          formData.append("title_en", this.title_en);
          formData.append("content_id", this.content_id);
          formData.append("content_en", this.content_en);
          formData.append("is_with_quick_cta_button", this.is_with_quick_cta_button);
          formData.append("quick_cta_button_text_id", this.quick_cta_button_text_id);
          formData.append("quick_cta_button_text_en", this.quick_cta_button_text_en);
          formData.append("quick_cta_button_url", this.quick_cta_button_url);
          formData.append("is_with_cta_button", this.is_with_cta_button);
          formData.append("cta_button_text_id", this.cta_button_text_id);
          formData.append("cta_button_text_en", this.cta_button_text_en);
          formData.append("cta_button_url", this.cta_button_url);
          formData.append("meta_description_id", this.meta_description_id);
          formData.append("meta_description_en", this.meta_description_en);
          formData.append("image", this.file);
          formData.append("image_webp", this.file_webp);
          if (this.period_start != "" && this.period_end == "") {
            const start = this.period_start.toJSON().slice(0, 10);
            formData.append("period_start", start);
            formData.append("period_end", this.period_end);
          }
          if (this.period_end != "" && this.period_start == "") {
            const end = this.period_end.toJSON().slice(0, 10);
            formData.append("period_start", this.period_start);
            formData.append("period_end", end);
          }
          if (this.period_start != "" && this.period_end != "") {
            const start = this.period_start.toJSON().slice(0, 10);
            const end = this.period_end.toJSON().slice(0, 10);

            formData.append("period_start", start);
            formData.append("period_end", end);
          }
          if (this.period_start == "" && this.period_end == "") {
            formData.append("period_start", this.period_start);
            formData.append("period_end", this.period_end);
          }
          formData.append("is_highlight", this.is_highlight);
          if (this.category === "promo") {
            formData.append("promo[promo_code]", this.promo_code);
          }
          $.each(this.tags, (key, value) => {
            formData.append("tags", value);
          });

          this.loading = true;
          this.$store
            .dispatch("ArticleModule/postArticles", formData)
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "Article" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500
              });
              console.log(response);
            })
            .catch(error => {
              this.loading = false;
              this.serverError = error.response.data;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500
              });
              console.log(error);
            });
        } else {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500
          });
        }
      });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
      const input = this.$refs.file;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.url = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileWebp() {
      this.file_webp = this.$refs.file_webp.files[0];
      const input = this.$refs.file_webp;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.url_webp = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    previewArticle() {
      const data = {
        category: this.category,
        image: this.url,
        image_alt: this.image_alt,
        title: this.title_id,
        content: this.content_id,
        is_with_quick_cta_button: this.is_with_quick_cta_button,
        quick_cta_button_text: this.quick_cta_button_text_id,
        quick_cta_button_url: this.quick_cta_button_url,
        is_with_cta_button: this.is_with_cta_button,
        cta_button_text: this.cta_button_text_id,
        cta_button_url: this.cta_button_url,
        meta_description: this.meta_description_id,
        tags: this.tags,
      }
      this.$session.set('previewArticle', data);
      let routePreviewArticle = this.$router.resolve({name: 'previewArticle'});
      window.open(routePreviewArticle.href, '_blank');
    }
  },
  computed: {
    disabledPeriodDatesEnd() {
      var disabledDates = {
        to: new Date(this.period_start - 8640000),
      };
      return disabledDates;
    },
    isPreviewDisabled() {
      let isPreviewDisabled = this.category === "" ||
        this.url === "" ||
        this.image_alt === "" ||
        this.title_id === "" ||
        this.meta_description_id == "" ||
        this.content_id === "";
      return isPreviewDisabled;
    }
  }
};
</script>

<style>
</style>
